import { render, staticRenderFns } from "./IngresanteFormDocente.vue?vue&type=template&id=ab296cc4&scoped=true&"
import script from "./IngresanteFormDocente.vue?vue&type=script&lang=js&"
export * from "./IngresanteFormDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab296cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
